import Layout from '@/layout'
const _import = path => () => import(`@/views/${path}`)

const constantRoutes = [
  // 注册
  {
    path: '/register',
    name: 'register',
    component: _import('login'),
    meta: { title: 'login.8', icon: 'user' },
    hidden: true,
    children: [
      {
        path: 'index',
        name: 'RegisterIndex',
        component: _import('login/register/index.vue'),
        meta: { title: 'login.8', icon: 'user', logo: true },
        hidden: true
      },
      {
        path: 'team',
        name: 'RegisterTeam',
        component: _import('login/register/register-team.vue'),
        meta: { title: 'login.12', icon: 'user', logo: true },
        hidden: true
      },
      {
        path: 'success',
        name: 'RegisterSuccess',
        component: _import('login/register/register-success.vue'),
        meta: { title: 'login.12', icon: 'user', logo: false },
        hidden: true
      }
    ]
  },
  // 登陆
  {
    path: '/login',
    name: 'login',
    component: _import('login'),
    meta: { title: '235', icon: 'user' },
    redirect: { name: 'index' },
    hidden: true,
    children: [
      {
        path: 'index',
        name: 'index',
        component: _import('login/login.vue'),
        meta: { title: '235', icon: 'user', logo: true },
        hidden: true
      },
      {
        path: 'loginCompany',
        name: 'loginCompany',
        component: _import('login/loginCompany'),
        meta: { title: '916', icon: 'user', logo: true },
        hidden: true
      },
      {
        path: 'create-company',
        name: 'create-company',
        component: _import('login/register/register-team.vue'),
        meta: { logo: true },
        hidden: true
      },
      {
        path: 'loginWarning',
        name: 'loginWarning',
        component: _import('login/loginWarning'),
        meta: { logo: true },
        hidden: true
      }
    ]
  },
  {
    path: '/404',
    component: _import('404'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    name: 'home',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: _import('dashboard/index'),
        meta: { title: '1108', icon: 'dashboard' }
      }
    ]
  },
  // 关于我们
  {
    path: '/info',
    component: _import('settings/about/info/info'),
    name: 'info',
    hidden: true
  }
]

export default constantRoutes
